import { createAction } from '@reduxjs/toolkit';

export const LOGOUT_ACTION = 'logout';

export const logout = createAction(LOGOUT_ACTION);
